import { render, staticRenderFns } from "./MyAddressBook.vue?vue&type=template&id=7573f7f3"
import script from "./MyAddressBook.vue?vue&type=script&lang=js"
export * from "./MyAddressBook.vue?vue&type=script&lang=js"
import style0 from "./MyAddressBook.vue?vue&type=style&index=0&id=7573f7f3&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports